import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import { Set } from 'immutable';

import { DISTRICTS, LANDS } from '../../consts';
import { count } from '../../utils/dictionaries';
import Checkbox from '../Controls/Checkbox';
import { Popup } from '../Popup';
import { normalizeLocalityDistricts } from '../../utils/formater';
import Territory from '../../classes/geo/territory';
import TerritorialDivisionModal from './TerritorialDivisionModal';

const suburbRegExp = new RegExp(DISTRICTS.suburb);

class TerritorialDivision extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      openedSelect: false,
      openedModal: false
    };

    this.territory = new Territory(props.domain);
    this.hasModal = this.hasModal();
    this.extendedLabel = this.getExtendedlabel();
    this.placeholder = props.realtyType === LANDS ? 'Район' : 'Район, микрорайон';

    this.onClickControl = this.onClickControl.bind(this);
    this.onClickModalControl = this.onClickModalControl.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.isSelectedItem = this.isSelectedItem.bind(this);
    this.getCounts = this.getCounts.bind(this);
  }

  hasModal () {
    if (this.props.realtyType === LANDS) {
      return false;
    }

    const countMD = this.territory.getCountMicroDistrict();
    const countRD = this.territory.getCountRegionDistricts();
    const countSW = this.territory.getCountSubways();

    return !!(countMD + countRD + countSW);
  }

  getExtendedlabel () {
    if (this.props.realtyType === LANDS) {
      return '';
    }

    const countMD = this.territory.getCountMicroDistrict();
    const countRD = this.territory.getCountRegionDistricts();
    const countSW = this.territory.getCountSubways();

    let label = (countMD > 0 ? ' по микрорайонам' : '');
    label = label || (countRD > 0 ? ' по области' : '');
    label = label || (countSW > 0 ? ' по метро' : '');

    return label;
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.openedSelect) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const nodeRef = findDOMNode(this.popupContainer);
    if (this.popupContainer !== e.target && nodeRef &&
        !nodeRef.contains(e.target) &&
        this.state.openedSelect
    ) {
      this.setState({ openedSelect: false });
    }
  }

  getCounts () {
    const filter = this.props.filter;
    const district = filter.get('district');

    const suburbCount = suburbRegExp.test(district) ? 1 : 0;
    const districtCount = count(filter, 'district') - suburbCount;
    const microdistrictCount = count(filter, 'microdistrict');
    const regionDistrictCount = count(filter, 'regionDistrict');
    const subwaysCount = count(filter, 'subwayId');

    return {
      suburbCount,
      districtCount,
      microdistrictCount,
      regionDistrictCount,
      subwaysCount
    };
  }

  isEmpty () {
    const {suburbCount, districtCount, microdistrictCount, regionDistrictCount, subwaysCount} = this.getCounts();
    return (suburbCount + districtCount + microdistrictCount + regionDistrictCount + subwaysCount) === 0;
  }

  getLabel () {
    const {suburbCount, districtCount, microdistrictCount, regionDistrictCount, subwaysCount} = this.getCounts();

    if (suburbCount || districtCount || microdistrictCount || regionDistrictCount || subwaysCount) {
      return [
        suburbCount ? 'область' : null,
        districtCount ? districtCount + ' - р-н.' : null,
        microdistrictCount ? microdistrictCount + ' - мкр-н.' : null,
        regionDistrictCount ? regionDistrictCount + ' - обл.р-н.' : null,
        subwaysCount ? subwaysCount + ' - ст.м.' : null
      ].filter(Boolean).join(', ');
    }

    return this.placeholder || 'dsds';
  }

  onClickControl () {
    const { microdistrictCount, regionDistrictCount, subwaysCount } = this.getCounts();
    const { openedSelect, openedModal } = this.state;

    if (openedSelect || openedModal) {
      this.setState({
        openedSelect: false,
        openedModal: false
      });
    } else if (microdistrictCount + regionDistrictCount + subwaysCount) {
      this.setState({
        openedSelect: false,
        openedModal: true
      });
    } else {
      this.setState({
        openedSelect: true,
        openedModal: false
      });
    }
  }

  onClickModalControl () {
    this.setState({
      openedSelect: false,
      openedModal: true
    });
  }

  isSelectedItem (id, field) {
    const value = this.props.filter.get(field);
    const selected = Set(value ? value.split(',') : []);
    return selected.has(String(id));
  }

  handlerSelect (field) {
    return (id, state) => {
      const value = this.props.filter.get(field);
      const selected = Set(value ? value.split(',') : []);

      const ids = state
          ? selected.add(String(id))
          : selected.delete(String(id));

      const filter = {
        [field]: ids.isEmpty() ? null : ids.join(',')
      };

      this.props.onUpdate(filter);
    };
  }

  renderModalControl () {
    return (
      <div className='extended-filter' onClick={this.onClickModalControl}>
        {'Подробный поиск' + this.extendedLabel}
      </div>
    );
  }

  renderSelect () {
    const { openedSelect } = this.state;
    const districts = normalizeLocalityDistricts(this.props.domain);

    return openedSelect && (
      <Popup
        indentation={false}
        opened
        direction='bottom-left'
        mainOffset={0}
        secondaryOffset={0} ref={p => { this.popupContainer = p; }}
      >
        <ul
          className={'multiselect-control-list'}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {
            districts.map(item => (
              <li key={item.id} className={'item item-' + item.id} >
                <Checkbox
                  key={item.id}
                  id={item.id}
                  label={item.name}
                  checked={this.isSelectedItem(item.id, 'district')}
                  onUpdate={this.handlerSelect('district')} />
              </li>
            ))
          }
        </ul>
        {
          this.hasModal && this.renderModalControl()
        }
      </Popup>
    );
  }

  renderModal () {
    const { openedModal } = this.state;
    const { domain, filter, onApply, onUpdate } = this.props;

    return (
      <TerritorialDivisionModal
        visible={openedModal}
        domain={domain}
        filter={filter}
        onClose={() => this.setState({openedModal: false})}
        onApply={onApply}
        onUpdateFilter={onUpdate} />
    );
  }

  render () {
    const { openedSelect, openedModal } = this.state;
    const opened = openedSelect || openedModal;

    const arrowClass = classNames(
        'button-select-value', 'button-flat', {
          'down': !opened,
          'up': opened
        });

    const textClass = classNames({
      'placeholder': this.isEmpty()
    });

    return (
      <Fragment>
        <div className='territorial-control-box'>
          <div className='territorial-control-value' onClick={this.onClickControl}>
            <button className={arrowClass} type='button'>
              <span className={textClass}>{this.getLabel()}</span>
            </button>
          </div>

          { this.renderSelect() }
        </div>

        { this.renderModal() }
      </Fragment>
    );
  }
}

TerritorialDivision.propTypes = {
  filter: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,
  realtyType: PropTypes.string,
  onApply: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};

TerritorialDivision.defaultProps = {};

export default TerritorialDivision;



// WEBPACK FOOTER //
// ./src/ui/TerritorialDivision/TerritorialDivision.jsx